import React from 'react'

import { MetaLayout } from 'components'
import HomePage from 'views/home/HomePage'
import { fetchRegions } from '../api'
import { Layout } from '../components'

const Index = ({ regions }) => {
  return (
    <MetaLayout
      title="Caribbean Restaurant Delivery, Grocery Delivery, Rides, Taxi, and Package Delivery"
      description="Get anything and everything delivered in St. Kitts, Nevis, Grenada, Dominica, BVI, and the Caribbean. Mobile topups, Uber rides, local packages, we do everything."
    >
      <HomePage
        mainImageUrl="food.jpg"
        serviceType=""
        regions={regions}
        title="Restaurants, groceries & more. Direct to your door!"
      />
    </MetaLayout>
  )
}

Index.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>
}

export async function getServerSideProps() {
  const { data } = await fetchRegions()
  const regions = data?.regions ?? []

  return {
    props: {
      regions
    }
  }
}

export default Index
